var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsIcon = function SvgSettingsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62484 7.375C7.45994 7.375 6.48112 6.57827 6.2036 5.5H1.75V4.25H6.2036C6.48112 3.17173 7.45994 2.375 8.62484 2.375C10.0055 2.375 11.1248 3.49429 11.1248 4.875C11.1248 6.25571 10.0055 7.375 8.62484 7.375ZM12.3752 4.25H14.2502V5.5H12.3752V4.25ZM5.50016 13.6251C4.33526 13.6251 3.35645 12.8283 3.07892 11.7501H1.75V10.5001H3.07892C3.35645 9.42181 4.33526 8.62508 5.50016 8.62508C6.88088 8.62508 8.00016 9.74437 8.00016 11.1251C8.00016 12.5058 6.88088 13.6251 5.50016 13.6251ZM9.25 11.7501H14.25V10.5001H9.25V11.7501ZM6.74984 11.125C6.74984 11.8154 6.19019 12.375 5.49984 12.375C4.80948 12.375 4.24984 11.8154 4.24984 11.125C4.24984 10.4346 4.80948 9.875 5.49984 9.875C6.19019 9.875 6.74984 10.4346 6.74984 11.125ZM9.875 4.87492C9.875 5.56527 9.31536 6.12492 8.625 6.12492C7.93464 6.12492 7.375 5.56527 7.375 4.87492C7.375 4.18456 7.93464 3.62492 8.625 3.62492C9.31536 3.62492 9.875 4.18456 9.875 4.87492Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settingsIcon.f653e36e.svg";
export { ForwardRef as ReactComponent };